module.exports = __webpack_public_path__ + "static/media/take-prize-run-out.66cdbf6e.png";